import { render, staticRenderFns } from "./ISASensorOffline.vue?vue&type=template&id=2c24d6c0&scoped=true&"
import script from "./ISASensorOffline.vue?vue&type=script&lang=js&"
export * from "./ISASensorOffline.vue?vue&type=script&lang=js&"
import style0 from "./ISASensorOffline.vue?vue&type=style&index=0&id=2c24d6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c24d6c0",
  null
  
)

export default component.exports